import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../data/translations';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage = () => {
  const { lang } = useLanguage();
  const { t, get } = useTranslation(lang);
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { window.scrollTo(0,0); setTimeout(()=>setLoaded(true),100); }, []);
  const p = t.privacy;

  const sections = [
    { title: get(p.dataTitle), text: get(p.dataText) },
    { title: get(p.cookieTitle), text: get(p.cookieText) },
    { title: get(p.rightsTitle), text: get(p.rightsText) },
    { title: get(p.contactTitle), text: get(p.contactText) },
  ];

  return (
    <div className="min-h-screen" style={{background:'#0a0a0a'}}>
      <div className="fixed inset-0 opacity-30 pointer-events-none z-0" style={{backgroundImage:`url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E")`,backgroundSize:'256px'}} />
      <div className="relative z-10">
        <div className="pt-28 md:pt-36 pb-12 px-8 md:px-16 lg:px-24">
          <button onClick={()=>navigate('/')} className="inline-flex items-center gap-2 text-gray-400 hover:text-white text-sm font-medium mb-8 transition-colors">
            <ArrowLeft size={16}/> {get(t.common.home)}
          </button>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white italic leading-tight max-w-4xl" style={{opacity:loaded?1:0,transform:loaded?'translateY(0)':'translateY(30px)',transition:'all 0.8s cubic-bezier(0.16,1,0.3,1)'}}>
            {get(p.title)}
          </h1>
        </div>

        <div className="px-8 md:px-16 lg:px-24 pb-8 max-w-4xl">
          <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-12">{get(p.intro)}</p>
          {sections.map((s, i) => (
            <div key={i} className="mb-10">
              <h2 className="text-xl md:text-2xl font-bold text-white mb-4">{s.title}</h2>
              <p className="text-gray-300 text-base leading-relaxed whitespace-pre-line">{s.text}</p>
            </div>
          ))}
        </div>

        <div className="px-8 md:px-16 lg:px-24 pb-20">
          <p className="text-xs text-gray-600">
            {get(t.contactPage.legalNote)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
